import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  FormText,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { InputField, SelectionField } from "../../../CommonElements";

import ImageInputField from "./ImageInputField";
import { H4 } from "../../../AbstractElements";
import { useStaf } from "../../../Context/StafContext";

const FormStaf = ({ toggle, data, isOpen }) => {
  const stafAPI = useStaf();
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues: data });
  // const axiosInstance = useAxios();
  const [statusStafOptions, setStatusStafOptions] = useState([]);
  // const [tipeStafOptions, setTipeStafOptions] = useState([]);
  const [groupStafOptions, setGroupStafOptions] = useState([]);
  const [atasanOptions, setAtasanOptions] = useState([]);
  const [submitState, setSubmitState] = useState("Submit");
  const [submitDisable, setSubmitDisable] = useState(false);
  const [fotoURL, setFotoURL] = useState(null);
  const [usernameLDAP, setUsernameLDAP] = useState(false);
  const [usernameSuggestions, setUsernameSuggestions] = useState([]);

  const nama = watch("nama");
  const username_ldap = watch("username_ldap");
  const isInitialRender = React.useRef(true);

  const createItem = (data) => {
    setSubmitDisable(true);
    stafAPI.createStaf(data).then(() => {
      toggle();
      setSubmitState("Submit");
      window.location.reload();
    });
  };

  const updateItem = (data) => {
    setSubmitDisable(true);
    stafAPI.updateStaf(data.id, data).then(() => {
      toggle();
      setSubmitState("Submit");
      window.location.reload();
    });
  };

  useEffect(() => {
    if (nama) {
      generateUsernameSuggestions(nama);
    } else {
      setUsernameSuggestions([]);
    }
  }, [nama]);

  const generateUsernameSuggestions = (fullName) => {
    const nameParts = fullName.toLowerCase().split(' ').filter(part => part.trim() !== '');
    let suggestions = new Set(); 

    if (nameParts.length === 1) {
      suggestions.add(`${nameParts[0]}123`);
      suggestions.add(`${nameParts[0]}`);
      suggestions.add(`${nameParts[0]}01`);
    } else {
      let dotSeparatedName = nameParts.join('.');
      suggestions.add(dotSeparatedName);
      
      if (nameParts.length >= 2) {
        suggestions.add(`${nameParts[0]}.${nameParts[1]}`);
      }
      
      if (nameParts.length > 2) {
        suggestions.add(`${nameParts[0]}.${nameParts[nameParts.length - 1]}`);
      }
      
      if (nameParts.length >= 3) {
        suggestions.add(`${nameParts[0]}.${nameParts[1]}.${nameParts[2]}`);
      }
    }

    setUsernameSuggestions([...suggestions]); 
  };

  const applyUsername = (suggestion) => {
    setValue("username_ldap", suggestion);
    checkUsername(suggestion);
  };

  useEffect(() => {
    if (isOpen) {
      fotoProfil();
    }
  }, [isOpen]);

  useEffect(() => {
    if (data?.username_ldap) {
      checkUsername(data.username_ldap);
    }
  }, [data?.username_ldap]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    if (username_ldap) {
      checkUsername(username_ldap);
    }
  }, [username_ldap]);

  const checkUsername = (username) => {
    const form = {
      username: username,
    };
    stafAPI.checkUsernameLDAP(form).then((res) => {
      setUsernameLDAP(res.data.available);
    });
  };

  const fotoProfil = () => {
    if (data?.foto_id) {
      stafAPI.getFotoProfilByID(data.foto_id).then((res) => {
        const url = URL.createObjectURL(res.data);
        setFotoURL(url);
      });
    }
  };

  let isMounted = true;
  useEffect(() => {
    StatusStaf();
    // TipeStaf();
    GroupStaf();
    Atasan();

    return () => {
      isMounted = false;
    };
  }, []);

  const StatusStaf = async () => {
    stafAPI.getStatusStaf().then((res) => {
      const statusStaf = res.data
        .map((staf) => ({
          id: staf.id_status_staf,
          name: staf.nama_status_staf,
        }))
        .sort((a, b) =>
          (a.nama_status_staf || "").localeCompare(b.name_status_staf || "")
        );
      setStatusStafOptions(statusStaf);
    });
  };

  // const TipeStaf = async () => {
  //   getTipeStaf(axiosInstance).then((res) => {
  //     const tipeStaf = res.data
  //       .map((staf) => ({
  //         id: staf.id_tipe_staf,
  //         name: staf.nama_tipe_staf,
  //       }))
  //       .sort((a, b) =>
  //         (a.nama_tipe_staf || "").localeCompare(b.nama_tipe_staf || "")
  //       );
  //     setTipeStafOptions(tipeStaf);
  //   });
  // };

  const GroupStaf = async () => {
    stafAPI.getGroupStaf().then((res) => {
      const groupStaf = res.data
        .map((staf) => ({
          id: staf.id_group,
          name: staf.nama,
        }))
        .sort((a, b) => (a.nama || "").localeCompare(b.nama || ""));
      setGroupStafOptions(groupStaf);
    });
  };

  const Atasan = async () => {
    stafAPI.getUserList().then((res) => {
      const atasan = res.data
        .map((staf) => ({
          id: staf.id,
          name: staf.nama,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setAtasanOptions(atasan);
    });
  };

  return (
    <Form onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createItem)}>
      <Row className={"my-4"} xl="3" sm="2" xs="1">
        <Col>
          <Controller
            name="foto_profil"
            control={control}
            render={({ field, fieldState }) => (
              <ImageInputField
                label={"Foto Profil"}
                fieldState={fieldState}
                {...field}
                maxSize={0.5}
                accept=".jpg, .jpeg, .png"
                defaultPreview={fotoURL}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="nama"
            control={control}
            rules={{
              required: "Harap masukkan nama",
            }}
            render={({ field, fieldState }) => (
              <InputField
                label={"Nama"}
                defaultValues={data?.nama}
                fieldState={fieldState}
                {...field}
                isRequired={true}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="nickname"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Nickname"}
                defaultValues={data?.nickname}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row className={"my-4"} xl="3" sm="2" xs="1">
        <Col>
          <Controller
            name="inisial"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Inisial"}
                defaultValues={data?.inisial}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="username_ldap"
            control={control}
            rules={{
              required: "Harap masukkan username LDAP",
            }}
            render={({ field, fieldState }) => (
              <>
                <InputField
                  label={"Username LDAP"}
                  defaultValues={data?.username_ldap}
                  fieldState={fieldState}
                  {...field}
                  isRequired={true}
                  valid={usernameLDAP}
                  validFeedback="Username LDAP terverifikasi"
                />
                {usernameSuggestions.length > 0 && !usernameLDAP && (
                  <FormText className="mb-3">
                    <div>Saran username: </div>
                    {usernameSuggestions.map((suggestion, index) => (
                      <span 
                        key={index} 
                        style={{ 
                          cursor: 'pointer',
                          marginRight: '10px',
                          color: '#007bff',
                          textDecoration: 'underline'
                        }}
                        onClick={() => applyUsername(suggestion)}
                      >
                        {suggestion}
                      </span>
                    ))}
                  </FormText>
                )}
              </>
            )}
          />
        </Col>
        <Col>
          <Controller
            name="email_lain"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Email Lain"}
                defaultValues={data?.email_lain}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row className={"my-4"}>
        <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
      </Row>
      <Row className={"my-4"} xl="3" sm="2" xs="1">
        <Col>
          <Controller
            name="nip"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"NIP"}
                defaultValues={data?.nip}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="nup_ui"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"NUP UI"}
                defaultValues={data?.nup_ui}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="golongan_pns"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Golongan PNS"}
                defaultValues={data?.golongan_pns}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row className={"my-4"} xl="3" sm="2" xs="1">
        <Col>
          <Controller
            name="ruangan"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"ruangan"}
                defaultValues={data?.ruangan}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="ext_telp"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Ext Telp"}
                defaultValues={data?.ext_telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="telp"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Telp"}
                defaultValues={data?.telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row className={"my-4"}>
        <Controller
          name="id_finger"
          control={control}
          render={({ field, fieldState }) => (
            <InputField
              label={"ID Finger"}
              defaultValues={data?.id_finger}
              fieldState={fieldState}
              {...field}
            />
          )}
        />
      </Row>
      <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
      <Row className={"my-4"} xl="2" xs="1">
        <Col>
          <Controller
            name="status_staf"
            control={control}
            rules={{
              required: "Harap masukkan status staf",
            }}
            render={({ field, fieldState }) => (
              <SelectionField
                label={"Status Staf"}
                defaultValues={data?.id_status_staf}
                placeholder={"Pilih Salah Satu"}
                options={statusStafOptions}
                fieldState={fieldState}
                {...field}
                isRequired={true}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="group_staf"
            control={control}
            rules={{
              required: "Harap masukkan group staf",
            }}
            render={({ field, fieldState }) => (
              <SelectionField
                label={"Group Staf"}
                defaultValues={data?.id_group_staf}
                placeholder={"Pilih Salah Satu"}
                options={groupStafOptions}
                fieldState={fieldState}
                {...field}
                isRequired={true}
              />
            )}
          />
        </Col>
      </Row>
      <Row className={"my-4"} xl="2" xs="1">
        <Col>
          <Controller
            name="atasan_1_id"
            control={control}
            render={({ field, fieldState }) => (
              <SelectionField
                label={"Atasan 1"}
                defaultValues={data?.atasan_1_id}
                placeholder={"Pilih Salah Satu"}
                options={atasanOptions}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
      <H4>Kontak Darurat</H4>
      <br />
      <Row className={"my-4"} xl="2" xs="1">
        <Col>
          <Controller
            name="nama_kontak_darurat"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Nama"}
                defaultValues={data?.telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="hubungan_kontak_darurat"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Hubungan"}
                defaultValues={data?.telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row xl="2" xs="1">
        <Col>
          <Controller
            name="alamat_kontak_darurat"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Alamat"}
                defaultValues={data?.telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
        <Col>
          <Controller
            name="telpon_kontak_darurat"
            control={control}
            render={({ field, fieldState }) => (
              <InputField
                label={"Telpon/HP"}
                defaultValues={data?.telp}
                fieldState={fieldState}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Button
        color="primary"
        type="submit"
        disabled={submitDisable}
        className="me-2"
      >
        {submitState}
      </Button>
    </Form>
  );
};

export default FormStaf;